// Aroma+ landing: one plan choice shared by every picker and join button, the phone join bar, and the add to cart.
(() => {
  const root = document.querySelector('[data-ap-plus]');
  if (!root) return;
  const plans = {
    monthly: { id: root.dataset.monthlyVariant, selling_plan: root.dataset.monthlyPlan, price: '$9.99/mo', terms: 'Renews monthly at $9.99 until you cancel. Cancel anytime from your account.' },
    yearly: { id: root.dataset.yearlyVariant, selling_plan: root.dataset.yearlyPlan, price: '$99.99/yr', terms: 'Renews yearly at $99.99 until you cancel. Cancel anytime from your account.' },
  };
  let choice = 'monthly';
  // Business IQ Lab (feature aroma_plus): page seen by a non-member, with where they came from (?source=cart etc.).
  if (!root.classList.contains('is-member')) {
    window.apTrack?.('aroma_plus_impression', { surface: 'page', source: new URLSearchParams(location.search).get('source') || '' }, 'aroma_plus');
  }

  // Both pickers (hero and plans) stay in step, and every price label follows the choice.
  const pick = (value) => {
    choice = plans[value] ? value : 'monthly';
    root.querySelectorAll('[data-ap-plus-pick] input').forEach((r) => { r.checked = r.value === choice; });
    root.querySelectorAll('[data-ap-plus-cta-price]').forEach((el) => { el.textContent = plans[choice].price; });
    root.querySelectorAll('[data-ap-plus-terms]').forEach((el) => { el.textContent = plans[choice].terms; });
  };
  root.addEventListener('change', (e) => { if (e.target.matches('[data-ap-plus-pick] input')) pick(e.target.value); });

  const say = (btn, text) => {
    const box = btn.closest('[data-ap-plus-join-box]') || root.querySelector('[data-ap-plus-join-box]');
    const out = box?.querySelector('[data-ap-plus-msg]');
    if (out) out.textContent = text;
  };
  root.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-ap-plus-join]');
    if (!btn || btn.disabled) return;
    const plan = plans[choice];
    btn.disabled = true;
    say(btn, 'Adding Aroma+…');
    window.apTrack?.('aroma_plus_click', { surface: 'page', plan: choice, source: btn.dataset.source || '' }, 'aroma_plus');
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(plan.id), quantity: 1, selling_plan: Number(plan.selling_plan) }] }),
      });
      if (!res.ok) throw new Error(String(res.status));
      window.location.href = '/cart';
    } catch {
      say(btn, "Aroma+ couldn't be added just now. Please try again.");
      btn.disabled = false;
    }
  });

  // Phone join bar: shows once the hero button has scrolled away, hides while any other join box is on screen.
  const bar = root.querySelector('[data-ap-plus-bar]');
  const heroCta = root.querySelector('[data-ap-plus-join][data-source="hero"]');
  if (!bar || !heroCta || !('IntersectionObserver' in window)) return;
  const boxes = [...root.querySelectorAll('[data-ap-plus-plans], [data-ap-plus-close]')];
  const seen = new Map([[heroCta, true]]);
  const paint = () => {
    const on = ![...seen.values()].some(Boolean);
    if (on && bar.hidden) { bar.hidden = false; requestAnimationFrame(() => requestAnimationFrame(paint)); return; }
    bar.classList.toggle('is-on', on);
    document.documentElement.classList.toggle('ap-plus-bar-on', on);
  };
  bar.addEventListener('transitionend', () => { if (!bar.classList.contains('is-on')) bar.hidden = true; });
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => seen.set(en.target, en.isIntersecting));
    paint();
  });
  [heroCta, ...boxes].forEach((el) => io.observe(el));
})();
